import { render } from "./NewOrder.vue?vue&type=template&id=0c267d66&scoped=true"
import script from "./NewOrder.vue?vue&type=script&lang=js"
export * from "./NewOrder.vue?vue&type=script&lang=js"

import "./NewOrder.vue?vue&type=style&index=0&id=0c267d66&scoped=true&lang=css"

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c267d66"]])

export default __exports__